import { createSelector } from "reselect";

import { EntityTypeSupportingCustomFields } from "@mapmycustomers/shared/types/entity";

import { RootState } from "../rootReducer";

import { stateFieldBaseName } from "./util";

const customFieldsState = (state: RootState) => state.customFields;

// same as selectors above, but accepts the entityType argument
export const getCustomFieldsForEntity = createSelector(
  [customFieldsState, (_, entityType: EntityTypeSupportingCustomFields) => entityType],
  (state, entityType) => {
    return state[stateFieldBaseName[entityType]];
  }
);

export const isCustomFieldDeleting = createSelector(
  customFieldsState,
  ({ customFieldDeleting }) => customFieldDeleting
);

export const isCustomFieldCreating = createSelector(
  customFieldsState,
  ({ customFieldCreating }) => customFieldCreating
);

export const isCustomFieldUpdating = createSelector(
  customFieldsState,
  ({ customFieldUpdating }) => customFieldUpdating
);
